document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.js-section-tools-and-technologies-block');

    sections.forEach((section) => {
        const desktopButtons = section.querySelectorAll('.js-section-tools-and-technologies-block-button');
        const mobileButtons = section.querySelectorAll('.js-section-tools-and-technologies-mobile-button');
        const sets = section.querySelectorAll('.js-section-tools-and-technologies-block-set');
        const indicator = section.querySelector('.js-section-tools-and-technologies-block-indicator-center');
        const details = section.querySelector('.js-section-tools-and-technologies-block-details');

        let maxHeight = 0;

        function isDesktopView() {
            return window.innerWidth > 992;
        }

        if (isDesktopView()) {
        sets.forEach((set) => {
            const originalDisplay = set.style.display;
            const originalPosition = set.style.position;
            const originalVisibility = set.style.visibility;
            const originalOpacity = set.style.opacity;
            if (!set.classList.contains('section-tools-and-technologies-block__set--active')) {
                set.style.display = 'flex'; // Ustaw display na block, aby można było zmierzyć wysokość
                set.style.position = 'absolute'; // Unikamy przesunięcia reszty układu
                set.style.visibility = 'hidden'; // Ustawienie na niewidoczne (ale dostępne do pomiaru)
                set.style.opacity = '0'; // Zmniejsz opacity do 0, aby zapobiec miganiu
            }

            const currentHeight = set.offsetHeight;

            console.log(currentHeight);

            if (currentHeight > maxHeight) {
                maxHeight = currentHeight;
            }

            set.style.display = originalDisplay;
            set.style.position = originalPosition;
            set.style.visibility = originalVisibility;
            set.style.opacity = originalOpacity;
        });


        details.style.height = `${maxHeight}px`;
        }

        function updateIndicatorPosition() {
            const activeButton = section.querySelector('.section-tools-and-technologies-block__button--active');
            if (activeButton && indicator) {
                indicator.style.top = `${activeButton.offsetTop + activeButton.offsetHeight / 2 - 40}px`;
            }
        }
        updateIndicatorPosition();

        desktopButtons.forEach((button, index) => {
            button.addEventListener('click', function () {
                desktopButtons.forEach(btn => btn.classList.remove('section-tools-and-technologies-block__button--active'));
                button.classList.add('section-tools-and-technologies-block__button--active');
                updateIndicatorPosition();

                sets.forEach((set, i) => {
                    set.classList.remove('section-tools-and-technologies-block__set--active');
                    if (i === index) {
                        set.classList.add('section-tools-and-technologies-block__set--active');
                    }
                });


            });
        });



        // Mobile version handling
        mobileButtons.forEach((button, index) => {
            button.addEventListener('click', function () {
                const set = sets[index];

                if (set.style.maxHeight) {
                    set.style.maxHeight = null;
                    button.classList.remove('section-tools-and-technologies-block__button--active');
                } else {
                    sets.forEach((otherSet) => {
                        otherSet.style.maxHeight = null;

                    });

                    mobileButtons.forEach((otherButton) => {
                        otherButton.classList.remove('section-tools-and-technologies-block__button--active');
                    });


                    button.classList.add('section-tools-and-technologies-block__button--active');
                    set.style.maxHeight = set.scrollHeight + "px";
                }
            });
        });
    });
});